import ROLES from "constants/user";
import useIsRoles from "hooks/useIsRoles";

const OBSERVER_ROLES = [ROLES.OBSERVER, ROLES.OBSERVER_SELLER];

export default function useIsObserverRole() {
  return useIsRoles(OBSERVER_ROLES);
}
